export interface MemberNickname {
    id: string;
    teamId: string;
    viewerId: string;
    targetId: string;
    nickname: string;
    createdAt: string;
}

// Explicit column allowlist for `member_nicknames` reads (SEC-M7). Keep in sync
// with `dbRowToMemberNickname` below — using `.select(MEMBER_NICKNAME_COLUMNS)`
// instead of `.select('*')` prevents future internal columns added to the
// table (e.g. moderation flags, audit fields, internal scoring) from auto-
// flowing to every authenticated client. Nicknames are scoped per (viewer,
// target) pair but the team-scoped read fans them out to every member.
export const MEMBER_NICKNAME_COLUMNS =
    'id, team_id, viewer_id, target_id, nickname, created_at';

export const dbRowToMemberNickname = (row: any): MemberNickname => ({
    id: row.id,
    teamId: row.team_id,
    viewerId: row.viewer_id,
    targetId: row.target_id,
    nickname: row.nickname,
    createdAt: row.created_at,
});
